var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmoothRide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1525_2675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.75 13C24.75 19.7655 19.2655 25.25 12.5 25.25C5.73451 25.25 0.25 19.7655 0.25 13C0.25 6.23451 5.73451 0.75 12.5 0.75C19.2655 0.75 24.75 6.23451 24.75 13Z",
    fill: "#FBB47E",
    stroke: "#D9925C",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 13C25 19.9062 19.4023 25.5 12.5 25.5C8.57031 25.5 5.0625 23.6875 2.76953 20.8477C4.91406 22.582 7.64453 23.6172 10.6172 23.6172C17.5195 23.6172 23.1172 18.0234 23.1172 11.1172C23.1172 8.14453 22.082 5.41406 20.3477 3.26953C23.1836 5.5625 25 9.07031 25 13Z",
    fill: "#D9925C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5403 10.2136C19.2348 10.3933 18.3309 9.42458 16.9114 9.37146C15.4419 9.31677 14.5879 10.3933 14.2825 10.2136C13.902 10.0832 14.4208 7.5988 16.9114 7.58942C19.4012 7.5988 19.9208 10.0832 19.5403 10.2136Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46014 10.2136C5.76561 10.3933 6.66952 9.42458 8.08905 9.37146C9.55858 9.31677 10.4125 10.3933 10.718 10.2136C11.0984 10.0832 10.5797 7.5988 8.08905 7.58942C5.5992 7.5988 5.07967 10.0832 5.46014 10.2136Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.283 14.5438C19.1697 14.3945 18.9944 14.3062 18.8084 14.3062H6.19441C6.00723 14.3062 5.83197 14.3933 5.71989 14.5426C5.60544 14.693 5.56967 14.8853 5.61974 15.0656C6.48174 18.133 9.31215 20.2763 12.5002 20.2763C15.6883 20.2763 18.5187 18.133 19.3807 15.0656C19.432 14.8853 19.3962 14.693 19.283 14.5438Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1525_2675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoothRide);
export default __webpack_public_path__ + "static/media/smooth_ride.8a8c1899773f34e022dcba600b6f7ffd.svg";
export { ForwardRef as ReactComponent };